/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Добавить должность в справочник.
 */
export interface JobTitleAdd { 
    /**
     * Наименование.
     */
    name?: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * УСТАРЕЛО! ID ассоциации.
     * @deprecated
     */
    parentOrganisationId?: string;
    /**
     * СОртировка.
     */
    sortOrder?: number;
}

